(() => {
  if (window.ivonneGiftEditorReady) return;
  window.ivonneGiftEditorReady = true;
  const instances = new Map();
  const desktop = matchMedia('(min-width: 990px)');
  function init(scope = document) {
    scope.querySelectorAll('[data-gift-rotation]').forEach(gift => {
      if (instances.has(gift)) return;
      const slides = [...gift.querySelectorAll('[data-gift-slide]')];
      const menu = gift.closest('.nav-dropdown');
      const control = gift.querySelector('[data-gift-toggle]');
      const seconds = Number(gift.dataset.giftInterval);
      const interval = Number.isFinite(seconds) ? Math.max(0, Math.min(30, seconds)) * 1000 : 5000;
      let current = 0, timer, paused = false;
      const events = new AbortController();
      const listen = (target, name, handler) => target?.addEventListener(name, handler, {signal: events.signal});
      function show(index) {
        current = index;
        slides.forEach((slide, i) => {
          const inactive = i !== current;
          slide.hidden = inactive;
          slide.inert = inactive;
          slide.setAttribute('aria-hidden', String(inactive));
        });
      }
      function canRotate() {
        return slides.length > 1 && interval > 0 && !paused && !document.hidden && desktop.matches && menu?.open && !gift.matches(':hover') && !gift.contains(document.activeElement);
      }
      function sync() {
        clearTimeout(timer);
        if (!menu?.open) show(0);
        if (!canRotate()) return;
        timer = setTimeout(() => { if (canRotate()) show((current + 1) % slides.length); sync(); }, interval);
      }
      if (control && slides.length > 1 && interval > 0) {
        control.hidden = false;
        listen(control, 'click', () => {
          paused = !paused;
          control.setAttribute('aria-label', paused ? control.dataset.playLabel : control.dataset.pauseLabel);
          control.querySelector('[data-gift-pause]').hidden = paused;
          control.querySelector('[data-gift-play]').hidden = !paused;
          sync();
        });
      }
      listen(menu, 'toggle', sync);
      listen(gift, 'pointerenter', sync);
      listen(gift, 'pointerleave', sync);
      listen(gift, 'focusin', sync);
      listen(gift, 'focusout', () => queueMicrotask(sync));
      show(0);
      instances.set(gift, {sync, destroy() { clearTimeout(timer); events.abort(); }});
      sync();
    });
  }
  document.addEventListener('visibilitychange', () => instances.forEach(instance => instance.sync()));
  desktop.addEventListener('change', () => instances.forEach(instance => instance.sync()));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, gift) => { if (event.target.contains(gift)) { instance.destroy(); instances.delete(gift); } });
  });
  document.addEventListener('shopify:block:select', event => {
    const id = event.detail?.blockId;
    document.querySelectorAll('[data-gift-block-id]').forEach(gift => {
      if (gift.dataset.giftBlockId !== id) return;
      const menu = gift.closest('.nav-dropdown');
      if (menu) menu.open = true;
      instances.get(gift)?.sync();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
})();
